<template>
  <el-dialog
    title="流转箱码下载"
    :visible.sync="visible"
    width="400px"
    append-to-body
    :close-on-press-escape="false"
    @closed="handleClose">
    <el-form
      ref="ruleForm"
      :model="ruleForm"
      :rules="rules"
      label-width="100px">
      <el-form-item
        label="起始序号:"
        prop="blandName">
        <el-input-number
          v-model="ruleForm.beginBoxNo"
          :min="1"
          :precision="0"
          :max="max"></el-input-number>
      </el-form-item>
      <el-form-item
        label="结束序号:"
        prop="blandName">
        <el-input-number
          v-model="ruleForm.endBoxNo"
          :min="1"
          :precision="0"
          :max="max"></el-input-number>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="visible = false">取 消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import Wms from '@/service/wms'
import { downloadBlobFile } from '@/utils/index'
export default {
  name: 'BoxCodeDownloadModal',
  data() {
    return {
      loading: false,
      visible: false,
      ruleForm: { beginBoxNo: 1, endBoxNo: 1 },
      max: 1,
      rules: {
        beginBoxNo: [{ required: true, message: '请输入起始序号', trigger: 'blur' }],
        endBoxNo: [{ required: true, message: '请输入结束序号', trigger: 'blur' }]
      }
    }
  },
  methods: {
    handleClose() {
      this.ruleForm.id = null
      this.ruleForm.blandName = ''
    },
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          const { beginBoxNo, endBoxNo } = this.ruleForm
          Wms.downloadappraisaltransferboxqrs({ beginBoxNo: Math.min(beginBoxNo, endBoxNo), endBoxNo: Math.max(beginBoxNo, endBoxNo) })
            .then(res => {
              this.loading = false
              this.visible = false
              downloadBlobFile(res)
              this.$message.success('下载成功')
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        }
      })
    },
    init(options = {}) {
      this.ruleForm = { ...this.ruleForm, ...options }
      this.max = options.endBoxNo
      this.visible = true
    }
  }
}
</script>
